import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { ConfirmDialog } from '@marvelapp/ballpark-components';
export default observer(function ChoiceLogicDeleteModal({ confirmDelete, trigger, isScreenerStep, }) {
    return (_jsx(ConfirmDialog, { onConfirmAction: confirmDelete, description: `Please note that deleting this option will also delete the ${isScreenerStep ? 'screening ' : 'conditional logic '}rule associated with it`, heading: 'Are you sure you want to delete this option?', onCloseDialog: trigger }));
});
